export default {
  /**
   * @param dates
   * @param filters
   * @returns Object
   */
  buildClientPaymentRequestBody(dates, filters) {
    return {
      arrival: {
        from: dates.arrivalFromDate,
        to: dates.arrivalToDate,
      },
      paidAt: {
        from: dates.paidDateFromDate,
        to: dates.paidDateToDate,
      },
      domains: filters.selectedDomains,
      brands: filters.selectedBrands,
    };
  },

  /**
   * @param dates
   * @param domain
   * @returns Object
   */
  buildClientPaymentSpecificationsRequestBody(dates, domain) {
    return {
      arrival: {
        from: dates.arrivalFromDate,
        to: dates.arrivalToDate,
      },
      paidAt: {
        from: dates.paidDateFromDate,
        to: dates.paidDateToDate,
      },
      domains: [domain],
    };
  },
};



// WEBPACK FOOTER //
// ./src/services/payment-service/client-payment-service-mappers.js